import Config from "../services/config";

export const formatFilePath = (path: string): string =>
{
    return `${Config.BACKEND_URI}/api/frontend/image?inputPath=${path}`;
};

export const getOriginalImage = (path: string): string =>
{
    return `${Config.BACKEND_URI}${path}`;
};


// WEBPACK FOOTER //
// ./src/util/media.ts